import SizeGuidePopUp from "@/components/common/SizeGuidePopUp";
import React, { useState, useEffect } from "react";
import { reportError } from "@/helpers/errorHelper";

import styles from "../../../ProductDetailsComp/Sections/sections.module.scss";
/*
This component will be use for showing the Product Details
1. Descriptions About the product
2. Product Options (Material, Size ... )
*/

export default function ProductDes({
  productInfo,
  showTitle = false,
  sizeGuideType,
  containsSizeDescrip,
  tagValue,
  isGiftcard
}) {
  var data;

  const [descriptionHtml, setDescriptionHtml] = useState('');

  useEffect(() => {
      if (productInfo) {
        try {
          const descriptionHtmlVar = (productInfo || '').replace(/([A-Za-z0-9])"|"$/g, '$1')
          .replace(/="\s*\\&quot;/g, '="').replace(/:="|:\s*"/g, ':').replace(/\\n/g, '') // Remove single newlines
          .replace(/^"|"$|\\&quot;/g, '').replace(/:="|:\s*"/g, ':') // Remove unnecessary colons before quotes
          .replace(/;=/g, ';') // Remove equal sign immediately after semicolon
          .replace(/:=/g, ':').replace(/;\\/g, ';') // Remove backslash immediately after semicolon
          .replace(/:\\/g, ':');    
          setDescriptionHtml(descriptionHtmlVar);
        } catch (error) {
          reportError("Error processing productInfo");
          reportError(error);
          // Optionally, you can set a fallback state or handle the error in another way
          setDescriptionHtml(''); // or some default value
        }
      }
  }, [productInfo]);

  if (productInfo) {
    // data = JSON.parse(JSON.parse(JSON.stringify(productInfo)));
    // descriptionHtml = data.descriptionHtml;
    return (
      <>
        <div className={styles["main-drawer"]}>
          {showTitle && (
            <div
              className={`small-xs large-sm x-large-md ${styles.productHeading}`}
              id="productDescHeading"
            >
              {(sizeGuideType && containsSizeDescrip !== 'undefined' && containsSizeDescrip)? " " : "Product details"}
            </div>
          )}
           <div
            className={styles.shopify_block}
            dangerouslySetInnerHTML={{ __html: isGiftcard ? JSON.parse(productInfo)?.descriptionHtml : descriptionHtml }}
          ></div>

          {sizeGuideType && containsSizeDescrip !== 'undefined' && containsSizeDescrip && (
            <div className={styles.sub_block}>
              <div
                id="productDescSizeGuide"
                className={`small-sm normal-md ${styles.free_shipping}`}
              >
                Not sure what size you are? Check out our{" "}
                <span className={`${styles.size__guide__wrapper}`}>
                  <SizeGuidePopUp sizeGuideType={sizeGuideType} className='size-guide-cta' pdp={true} />
                  </span> or contact our <a href="mailto:help@olivela.com" className="pdp-ga4-click-trigger" data-pdpGa4={`PDP Size & fit click > ${tagValue} > Contact`} tabIndex={0}>Customer care</a> team
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
}
